import {
  FILTER_DESELECT_ALL,
  FILTER_SELECT_ALL,
  SET_REPORT_DATA,
  UPDATE_FILTER,
  SET_FILTERS_DIRTY,
} from '../constants';

const isFiltersDirty = (state = false, action) => {
  switch (action.type) {
    case SET_REPORT_DATA:
      return false;
    case FILTER_SELECT_ALL:
    case FILTER_DESELECT_ALL:
    case UPDATE_FILTER:
    case SET_FILTERS_DIRTY:
      return true;
    default:
      return state;
  }
};

export default isFiltersDirty;
